<template>
    <section>
        <div class="container-fluid">
            <button @click="addArticle" class="btn btn-success mb-3" v-if="currentUser.type === 1">
                <font-awesome-icon icon="plus" size="sm" />&nbsp;AGGIUNGI NEWS
            </button>
            <div class="card-columns" v-if="articles.data">
                <div class="card single-article" v-for="(article, i) in articles.data" :key="`artcile-${i}`">
                    <!-- <img class="card-img-top" src="" alt="Card image cap"> -->
                    <div class="card-header">
                        <h5 class="card-title">{{ article.title }}</h5>
                        <small class="text-muted">
                            {{ $date(article.updated_at).format('DD-MM-YYYY | HH:mm') }}
                        </small>
                    </div>
                    <div class="card-body">
                        <div class="card-text" v-html="article.body" />
                    </div>
                    <div v-if="currentUser.type === 1" class="card-footer">
                        <button @click="deleteArticle(article.id)" class="btn btn-danger" v-if="currentUser.type === 1">
                            <font-awesome-icon icon="trash-alt" size="sm" />&nbsp;ELIMINA
                        </button>
                        <button @click="editArticle(article)" class="btn btn-warning" v-if="currentUser.type === 1">
                            <font-awesome-icon :icon="['far', 'edit']" size="sm" />&nbsp;MODIFICA
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <article-modal :article="currentArticle" @new-article-created="fetchArticles" />
    </section>
</template>
<script>
import { Article } from '@/models/Article'
import { mapGetters } from 'vuex'
import {
    GET_LIST,
    DELETE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/articles.module'
const DEFAULT_QUERY = {
    _page: 1,
    _limit: 10,
    _sort: 'project_name',
    _asc: 1
}
export default {
    name: 'articles-list',
    mounted () {
        this.fetchArticles()
    },
    data () {
        return {
            currentArticle: new Article(),
            columns: {
                title: {
                    label: 'Titolo',
                    sortable: true
                },
                author: {
                    label: 'Creato da'
                },
                created_at: {
                    label: 'Data creazione',
                    sortable: true,
                },
                updated_at: {
                    label: 'Data modifica',
                    sortable: true,
                },
                actions: {
                    label: ''
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            articles: `${MODULE_NAME}/getList`
        }),
        query: {
            get () {
                return Object.keys(this.$route.query).length == 0 ? DEFAULT_QUERY : this.$route.query
            },
            set (new_query) {
                this.$router.replace({
                    query: {
                        ...new_query
                    }
                })
            }
        }
    },
    watch: {
        $route () {
            this.fetchArticles()
        }
    },
    methods: {
        fetchArticles () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        },
        openDetail (articleId) {
            this.$router.push({
                name: 'article-detail',
                params: {
                    id: articleId
                }
            })
        },
        addArticle () {
            this.currentArticle = new Article()
            this.$modal.show('article-modal')
        },
        editArticle (article) {
            this.currentArticle = new Article(article)
            this.$modal.show('article-modal')
        },
        deleteArticle (articleId) {
            this.$swal({
                title: 'Sei sicuro?',
                text: 'Una volta eliminato non potrai più recuperare questa news!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminalo!'
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$store.dispatch(`${MODULE_NAME}/${DELETE}`, articleId).then(() => {
                        this.fetchArticles()
                    })
                } else {
                    this.$swal('Bene!', 'La news non è stata eliminata!')
                }
            })
        }
    },
    components: {
        ArticleModal: () => import('./ArticleModal'),
        // PaginatedTable: () => import('@/components/PaginatedTable')
    }
}
</script>
<style lang="scss">
.single-article {
    .card-title {
        line-height: 1.6rem;
    }
    img {
        max-width: 100%;
    }
}
</style>
